<template>
  <div class="left-container">
    <e-dynamic-tree
      class="root-tree"
      v-if="appData.treeConfig.itemsAsTree"
      v-show="!activeSearch"
      :data="appData.treeConfig.itemsAsTree"
      @select="appData.onItemSelect"
      @loadChildren="appData.treeConfig.loadChildren"
      ref="tree"
    >
      <template slot-scope="props">
        <img class="level-icon" :src="'levelicons/' + getLevel(props.node) + '.png'" />
        <span :class="'color' + (props.node.kind || 0)" :title="props.node.name">{{ props.node.name }}</span>
      </template>
    </e-dynamic-tree>
    <list
      v-if="appData.searchListConfig.items.length"
      v-show="activeSearch"
      :config="appData.searchListConfig"
      @itemselect="appData.onItemSelect"
    ></list>
  </div>
</template>

<script>
import List from './List';
import {Utils} from '@elo/core'

export default {
  name: 'EVNavigation',
  components: {List},
  props: {activeSearch: Boolean},
  inject: ['appData'],
  data() {
    return {};
  },
  methods: {
    getLevel(item) {
      // EEV-22: Auf elo lib umgestellt
      const isEmpty = !item.ext && !item.childsAsTree;

      return Utils.getLevel(item.type, false, isEmpty);
    }
  },
  computed: {}
};
</script>

<style>
</style>
